import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import KampaayerForm from './KampaayerForm'

const KampaayerCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <KampaayerForm />
      </Create>
    </SectionWrapper>
  )
}

export default KampaayerCreate
